import Button, { ButtonVariants } from 'components/button/button';
import LabelAndInput from 'components/label-and-input/labelAndInput';
import {
  arrowRightIcon,
  clockIcon,
  CONTENT_TYPE,
  playlistsIcon,
  ROUTES,
  templatesGreyIcon,
  videoIcon,
  WebIcon,
} from 'constants/index';
import ShareAccess from 'components/share-access/shareAccess';
import { itemType, ModalViews } from 'enums';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
import { useStore } from 'store';
import {
  homePageActions,
  layoutActions,
  playlistPageActions,
} from 'store/actions';
import { iState } from 'types';
import styles from './details.module.scss';

interface iProps {
  className?: string;
  variant?: 'desktop' | 'mobile';
}

function Index(props: iProps): JSX.Element {
  const { className, variant = 'desktop' } = props;
  const [state, dispatch]: [iState, any] = useStore();
  const { homePage } = state || {};
  const { screenData, isSaveAndCloseDisabled } = homePage || {};
  const { playListAccess, contentAcces } = state.user.userPermissions || {};
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState<boolean>(true);

  const onChange = useCallback(
    (event) => {
      const temp = { ...screenData };
      temp[event.target.name] = event.target.value;
      dispatch(homePageActions.updateScreenData(temp));
      if (isSaveAndCloseDisabled)
        dispatch(homePageActions.setIsSaveAndCloseDisabled(false));
    },
    [dispatch, screenData, isSaveAndCloseDisabled]
  );

  const { currentContent, currentPlayList, id, name, hashCode } =
    screenData || {};

  useEffect(() => {
    if (contentAcces === 'disabled' && playListAccess === 'disabled') {
      setShowContent(false);
    } else setShowContent(true);
  }, [contentAcces, playListAccess]);

  return (
    <div className={`${className} ${styles.details}`}>
      {variant === 'desktop' && (
        <div className={styles.header}>
          <Button
            className={styles.screenBtn}
            variant={ButtonVariants.ChangeView}
            btnName="Screen"
            isActive
          />
        </div>
      )}
      <div className={styles.screenNameAndHashCode}>
        <LabelAndInput
          className={styles.screenName}
          value={name || ''}
          name="name"
          placeholder="Screen Name"
          label="Screen Name"
          onChange={onChange}
        />
        <LabelAndInput
          className={styles.disabled}
          value={hashCode || ''}
          name="hashCode"
          label="Screen Hash"
          placeholder="Screen Hash"
          disabled
          onChange={(e) => onChange(e)}
        />
      </div>
      <div
        className={`${styles.contentSection} ${
          showContent === false && styles.hideContent
        }`}
      >
        <p className={styles.sectionHeading}>Content</p>

        {currentContent && (
          <div className={styles.content}>
            <div className={styles.nameSection}>
              <div className={styles.contentPreview}>
                {currentContent.contentType === CONTENT_TYPE.Image && (
                  <img src={currentContent.url} alt="" />
                )}
                {currentContent.contentType === CONTENT_TYPE.Video && (
                  <img src={videoIcon} alt="" />
                )}
                {currentContent.contentType === CONTENT_TYPE.Website && (
                  <img src={WebIcon} alt="" />
                )}
                {currentContent.contentType === CONTENT_TYPE.Template && (
                  <img src={templatesGreyIcon} alt="" />
                )}
              </div>
              <p className={styles.contentName}>
                {currentContent.name.length > 32
                  ? `${currentContent.name.slice(0, 32)}...`
                  : currentContent.name}
              </p>
            </div>
            <div className={styles.timeSection}>
              <img
                className={styles.arrowRightIcon}
                src={arrowRightIcon}
                alt=""
                onClick={() => {
                  dispatch(homePageActions.setScreensActiveFolder(null));
                  navigate(ROUTES.content);
                }}
              />
            </div>
          </div>
        )}
        {currentPlayList && (
          <div className={styles.content}>
            <div className={styles.nameSection}>
              <div className={styles.contentPreview}>
                <img src={playlistsIcon} alt="" />
              </div>

              <p className={styles.contentName}>
                {currentPlayList.name.length > 32
                  ? `${currentPlayList.name.slice(0, 32)}...`
                  : currentPlayList.name}
              </p>
            </div>
            <div className={styles.timeSection}>
              <img className={styles.clockIcon} src={clockIcon} alt="" />
              <span className={styles.duration}>
                {currentPlayList.duration || '00:00'}
              </span>
              <img
                className={styles.arrowRightIcon}
                src={arrowRightIcon}
                alt=""
                onClick={() => {
                  dispatch(
                    playlistPageActions.setPlaylistData(currentPlayList)
                  );
                  navigate(ROUTES.playlist);
                }}
              />
            </div>
          </div>
        )}
        <Button
          className={styles.changeContentBtn}
          btnName="Change Contents"
          variant={ButtonVariants.ChangeView}
          onClick={() =>
            dispatch(
              layoutActions.toggleModal(
                ModalViews.isShowAssignContentOrPlaylist
              )
            )
          }
        />
      </div>
      <ShareAccess
        className={styles.shareAccess}
        shareType={itemType.SCREEN}
        heading={name || 'Screen'}
        shareItemId={id}
      />
    </div>
  );
}

Index.defaultProps = {
  className: '',
  variant: 'desktop',
};

export default Index;
